import { hasValidHours } from './hasValidHours';
import { hasValidAddress } from './hasValidAddress';
import { hasValidPhoneNumbers } from './hasValidPhoneNumbers';
import { buildAddress } from './buildAddress';

/**
 * Check if department is sales department
 * @param {string} label - Department label
 * @returns {boolean} - True if sales department
 */
const isSalesDepartment = (label) => {
	return label?.toUpperCase().includes('SALES');
};

/**
 * Check if department is valid (has at least one valid field and is not a sales department)
 * @param {ADDDepartment} department - Department object
 * @returns {boolean} - True if department is valid
 */
export const isDepartmentValid = (department) => {
	const fullAddress = buildAddress(department);
	const hasAddress = hasValidAddress(fullAddress);
	const { hours, contactInformation, label } = department;
	const hasHours = hasValidHours(hours);
	const hasPhoneNumbers = hasValidPhoneNumbers(contactInformation);

	const hasValidData = hasAddress || hasHours || hasPhoneNumbers;

	const isNotSales = !isSalesDepartment(label);

	return hasValidData && isNotSales;
};
